/**
 * Função para ordenar uma lista de objetos por uma determinada propriedade.
 * @template T
 * @param {T[]} dataList - Lista de objetos a ser ordenada.
 * @param {string} property - Propriedade pela qual os objetos devem ser ordenados.
 * @param {'ASC' | 'DESC'} order - Ordem da ordenação ('asc' para ascendente, 'desc' para descendente).
 * @returns {T[]} - Lista ordenada de objetos.
 */
export function sortByProperty(dataList, property, order) {
  return dataList.sort((a, b) => {
    let comparison = 0;
    const propA = a[property];
    const propB = b[property];

    if (typeof propA === 'string' && typeof propB === 'string') {
        comparison = propA.localeCompare(propB);
    } else if (typeof propA === 'number' && typeof propB === 'number') {
        comparison = propA - propB;
    }

    return order === 'DESC' ? comparison * -1 : comparison;
  });
}
